<template>
    <div v-if="isLoaded">
        <div class="scrollto" @click="isActive=false">
            <div class="wrapper" style="min-height: 880px">
                <div class="columns">
                    <div class="column is-9-widescreen is-9-fullhd">
                        <div class="is-flex vertical-align-middle is-align-items-start is-justify-content-space-between">
                            <span @click="$store.commit('search/SET_BACKBTN_RESULTS', true),$router.back()" class="btn btn-clear btn-back">Back</span>
                            <div class="is-flex-mobile is-flex-direction-column is-flex-direction-column-reverse">
                                <section class="platform-filter">
                                    <b-dropdown
                                        v-model="filterPlatformOptions"
                                        multiple
                                        ref="platformFilter"
                                        aria-role="list"
                                        position="is-bottom-left">
                                        <template #trigger>
                                            <b-button
                                                type="is-primary"
                                                icon-right="menu-down"
                                                class="btn-platform">
                                                <p v-if="platformAllCheckSaved" class="content">With a platform</p>
                                                <p v-else-if="platformNoCheckSaved" class="content">Without a platform</p>
                                                <p v-else-if="filterPlatformOptionsSaved && filterPlatformOptionsSaved.length" class="content">
                                                    {{
                                                        filterPlatformOptionsSaved.join(' : ')
                                                    }}
                                                </p>
                                                <p v-else class="content">
                                                    Filter by Platform
                                                </p>
                                            </b-button>
                                        </template>
                                        <b-dropdown-item v-for="(item, index) in listPlatform" :value="item" :key="item.id" aria-role="listitem" :disabled="selectedDisabled" :class="index == listPlatform.length -1 ? 'item-last': '' ">
                                            <span class="check"></span><span>{{item.platform_name || item.platform}}</span>
                                        </b-dropdown-item>
                                        <div class="dropdown-item-bottom">
                                            <b-icon
                                                class="scroll-down is-hidden-tablet"
                                                icon="chevron-double-down"
                                                size="is-small">
                                            </b-icon>
                                            <div class="p-t-1 dropdown-item-bottom-checkbox">
                                                <b-checkbox v-model="platformAllCheck" v-on:click.native="selectedDisabled=!platformAllCheck, platformNoCheck=false, filterPlatformOptions=[]">
                                                    Funds with a platform
                                                </b-checkbox>
                                            </div>
                                            <div class="dropdown-item-bottom-checkbox">
                                                <b-checkbox v-model="platformNoCheck" v-on:click.native="selectedDisabled=!platformNoCheck, platformAllCheck=false, filterPlatformOptions=[]">
                                                    Funds without a platform
                                                </b-checkbox>
                                            </div>
                                            <div class="p-b-1 dropdown-item-bottom-checkbox is-flex is-justify-content-space-between">
                                                <button class="button btn-clear" @click="filterPlatformOptions=[], selectedDisabled=platformAllCheck=platformNoCheck=false">CLEAR</button>
                                                <button class="button is-primary" @click="filterPlatform">DONE</button>
                                            </div>
                                        </div>
                                    </b-dropdown>
                                </section>

                                <section id="benchmark-filter" class="benchmark-filter mb-2 mt-2">
                                    <b-dropdown
                                        v-model="filterBenchmarkSelected"
                                        :disabled="isSpreadBenchmarkAdvancedFilter"
                                        ref="benchmarkFilter"
                                        aria-role="list"
                                        position="is-bottom-left">
                                        <template #trigger>
                                            <b-button
                                                type="is-primary"
                                                icon-right="menu-down"
                                                class="btn-platform btn-benchmark">
                                                <p v-if="filterBenchmarkSelected" class="content">
                                                   Spread vs {{filterBenchmarkSelected.description}}
                                                </p>
                                                <p v-else class="content">
                                                    Compare to Benchmark
                                                </p>
                                            </b-button>
                                        </template>
                                        <b-dropdown-item @click="filterCompareBenchmark" v-for="(item, index) in listCompareBenchmark" :value="item" :key="item.id" aria-role="listitem" :disabled="selectedDisabled" :class="index == listCompareBenchmark.length -1 ? 'item-last': '' ">
                                            <span class="check"></span><span>{{item.description}}</span>
                                        </b-dropdown-item>
                                        <div class="dropdown-item-bottom">
                                            <b-icon
                                                class="scroll-down is-hidden-tablet"
                                                icon="chevron-double-down"
                                                size="is-small">
                                            </b-icon>
                                            <div class="p-b-1 dropdown-item-bottom-checkbox is-flex is-justify-content-space-between">
                                                <button class="button btn-clear" @click="filterBenchmarkSelected=null, clearFilterCompareBenchmark()">CLEAR</button>
<!--                                                <button class="button is-primary" @click="filterCompareBenchmark">DONE</button>-->
                                            </div>
                                        </div>
                                    </b-dropdown>
                                </section>
                            </div>
                        </div>
                      
                        <div class="is-hidden-mobile header-search m-b-0-mobile buttons-home-sticky border-bottom-hidden-mobile">
                            <h1 class="is-flex is-align-items-center w-100 is-size-6 is-size-3-tablet has-text-weight-bold m-b-0">
                                <img v-if="!$store.state.shortlist.showShortlist" src="/img/search-icon.png" class="icon-title is-size-4">
                                <div class="is-hidden-tablet">
                                    <span v-if="$store.state.shortlist.showShortlist" class="is-size-5 is-size-4-desktop has-text-weight-bold mr-5">Shortlist</span>
                                    <span v-else class="is-size-4-desktop has-text-weight-bold mr-5">
                                        <template v-if="checkSearchEmpty">
                                            <span v-if="checkSearchEmpty.length<15" class="is-size-5">{{checkSearchEmpty}}</span>
                                            <span v-else-if="checkSearchEmpty.length>=15 && checkSearchEmpty.length<40" class="is-size-6">{{checkSearchEmpty}}</span>
                                            <span v-else-if="checkSearchEmpty.length>=40" class="is-size-7">{{checkSearchEmpty}}</span>
                                        </template>
                                    </span>
                                </div>
                                <div class="is-hidden-mobile">
                                    <span class="is-size-5 is-size-4-desktop has-text-weight-bold mr-5">{{$store.state.shortlist.showShortlist ? 'Shortlist' : checkSearchEmpty}}</span>
                                </div>
                                <div v-if="!$store.state.shortlist.showShortlist" class="is-hidden-mobile">
                                    <PageHelpDropdown  :height="'560px'" :pageHelp="'results'"/>
                                </div>
                                <div v-else class="is-hidden-mobile">
                                    <PageHelpDropdown :height="'560px'" :pageHelp="'shortlist'"/>
                                </div>
                            </h1>
                            <div class="is-hidden-mobile">
                                <div class="ml-0 see-returns view-toggle">
                                    <currency-toggle v-on:currency-change="currencyChange" :is-disabled="benchmarkFilterSelected"/>
                                </div>
                            </div>
                            <div class="is-hidden-tablet">
                                <div class="ml-0 see-returns view-toggle">
                                    <currency-toggle v-on:currency-change="currencyChange" :is-disabled="benchmarkFilterSelected"/>
                                </div>
                            </div>
                        </div>
                        <div class="sticky" style="position: sticky; top: 59px; background: rgb(245, 244, 244); z-index: 10; padding: 0 10px;">
                            <div class="filters-wrapper border-bottom border-bottom-hidden-mobile">
                                <div v-if="!$store.state.shortlist.showShortlist" class="filters m-t-5-tablet">
                                    <h2 class="is-size-6 is-size-4-tablet has-text-weight-bold m-b-5 m-t-5 m-r-20">{{ $store.state.search.searchData.total }}
                                        <span v-if="$store.state.search.searchData.total != $store.state.search.searchData.total_search">of {{ $store.state.search.searchData.total_search }} </span>
                                        <span v-if="$store.state.search.searchData.total_search > 1">funds</span>
                                        <span v-else>fund</span>
                                    </h2>

                                    <span style="text-decoration: underline;cursor: pointer" class="has-text-primary m-r-20" v-if="$store.state.search.searchData.total != $store.state.search.searchData.total_search" @click="clearAll()" >show all</span>

                                    <button @click="newtotal=pageTotal, basic=true" class="btn btn-filter ">BASIC FILTERS <span class="count-filters" v-bind:class="$store.state.search.countFiltersBasic < 10 ? 'small-circle' : 'large-circle'">{{$store.state.search.countFiltersBasic}}</span></button>
                                    <button @click="openPopupAdvancedFilter" class="btn btn-filter">ADVANCED FILTERS <span  class="count-filters"  v-bind:class="$store.state.search.countFiltersAdvance < 10 ? 'small-circle' : 'large-circle'">{{$store.state.search.countFiltersAdvance}}</span></button>

                                    <!--<button @click="clearAll()" class="btn btn-clear">CLEAR FILTERS</button>-->
                                    <div class="ml-4 see-returns">
                                        <currency-toggle v-on:currency-change="currencyChange" :is-disabled="benchmarkFilterSelected"/>
                                    </div>


                                    <div class="collapse">
                                        <a class="ml-4 is-has-text-nowrap expand-collapse-link has-text-underline" @click="showall = !showall">
                                            <template v-if="showall">
                                                Collapse All
                                            </template>
                                            <template v-else>
                                                Expand All
                                            </template>
                                        </a>
                                    </div>
                                </div>
                                <div v-else class="filters">
                                    <h2 class="is-size-6 is-size-4-tablet has-text-weight-bold m-b-5 m-t-5 m-r-20">
                                        {{$store.state.shortlist.fullshortlist.length}}
                                        <span v-if="$store.state.shortlist.fullshortlist.length > 1">funds</span>
                                        <span v-else>Fund</span>
                                    </h2>

                                    <div class="around-space see-returns">
                                        <currency-toggle v-on:currency-change="currencyChange" :is-disabled="benchmarkFilterSelected"/>
                                    </div>
                                    <div class="ml-6 see-returns">
                                        <button @click="addAllFundsClick" class="button is-primary btn-add-all-funds">ADD ALL FUNDS TO WATCHLISTS</button>
                                    </div>
                                    <div class="collapse">
                                        <a class="ml-5 is-has-text-nowrap expand-collapse-link has-text-underline" @click="showall = !showall">
                                            <template v-if="showall">
                                                Collapse All
                                            </template>
                                            <template v-else>
                                                Expand All
                                            </template>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <b-modal
                            v-model="basic"
                            has-modal-card
                            full-screen
                            :can-cancel="false">
                            <basic-filter
                                v-on:working-filter="(e) => isWorkingOnFilters=e"
                                v-on:search-filter="filterReturned=$event,lastSearch()"
                                v-on:provisional-count="provisionalCount($event)"
                                v-on:switch-it="switchIt()"
                                v-on:checkBasicFilterShowAll="checkBasicFilterShowAll"

                                :clean="clean"
                                :filterPresets="filterPresets"
                                :filterReturned="filterReturned"
                                :preFilterTotal="preFilterTotal"
                                @scrollPageToTopAfterFilter='goToTopPageSearchList'
                            ></basic-filter>
                        </b-modal>

                        <b-modal
                            v-model="advanced"
                            has-modal-card
                            full-screen
                            :can-cancel="false">
                            <advanced-filter
                                v-on:working-filter="(e) => isWorkingOnFilters=e"
                                v-on:search-filter="filterReturned=$event,lastSearch()"
                                v-on:provisional-count="provisionalCount($event)"
                                v-on:switch-it="switchIt()"

                                :clean="clean"
                                :absoluteTotal="absoluteTotal"
                                :newtotal="newtotal"
                                :filterPresets="filterPresets"
                                :filterReturned="filterReturned"
                                :preFilterTotal="preFilterTotal"
                                @scrollPageToTopAfterFilter='goToTopPageSearchList'
                            ></advanced-filter>
                        </b-modal>

                      <div class="header-scroll-sticky-mobile">
                        <div class="is-hidden-tablet header-search m-b-0-mobile buttons-home-sticky border-bottom-hidden-mobile">
                            <h1 class="is-flex is-align-items-center w-100 is-size-6 is-size-3-tablet has-text-weight-bold m-b-0">
                                <img v-if="!$store.state.shortlist.showShortlist" src="/img/search-icon.png" class="icon-title is-size-4">
                                <div class="is-hidden-tablet">
                                    <span v-if="$store.state.shortlist.showShortlist" class="is-size-5 is-size-4-desktop has-text-weight-bold mr-5">Shortlist</span>
                                    <span v-else class="is-size-4-desktop has-text-weight-bold mr-5">
                                        <template v-if="checkSearchEmpty">
                                            <span v-if="checkSearchEmpty.length<15" class="is-size-5">{{checkSearchEmpty}}</span>
                                            <span v-else-if="checkSearchEmpty.length>=15 && checkSearchEmpty.length<40" class="is-size-6">{{checkSearchEmpty}}</span>
                                            <span v-else-if="checkSearchEmpty.length>=40" class="is-size-7">{{checkSearchEmpty}}</span>
                                        </template>
                                    </span>
                                </div>
                                <div class="is-hidden-mobile">
                                    <span class="is-size-5 is-size-4-desktop has-text-weight-bold mr-5">{{$store.state.shortlist.showShortlist ? 'Shortlist' : checkSearchEmpty}}</span>
                                </div>
                                <div v-if="!$store.state.shortlist.showShortlist" class="is-hidden-mobile">
                                    <PageHelpDropdown  :height="'560px'" :pageHelp="'results'"/>
                                </div>
                                <div v-else class="is-hidden-mobile">
                                    <PageHelpDropdown :height="'560px'" :pageHelp="'shortlist'"/>
                                </div>
                            </h1>
                            <div class="is-hidden-mobile">
                                <div class="ml-0 see-returns view-toggle">
                                    <currency-toggle v-on:currency-change="currencyChange" :is-disabled="benchmarkFilterSelected"/>
                                </div>
                            </div>
                            <div class="is-hidden-tablet">
                                <div class="ml-0 see-returns view-toggle">
                                    <currency-toggle v-on:currency-change="currencyChange" :is-disabled="benchmarkFilterSelected"/>
                                </div>
                            </div>
                        </div>
                        <div class="sort-wrapper m-b-10-mobile border-bottom-hidden-tablet buttons-home-sticky top-100">
                            <div class="columns is-mobile m-b-0-mobile">
                                <div class="column is-6 is-hidden-tablet pr-0">
                                    <h2 v-if="!$store.state.shortlist.showShortlist" class="is-size-6 is-size-4-tablet has-text-weight-bold m-b-5 m-t-5 is-hidden-tablet">{{ $store.state.search.searchData.total }}
                                        <span v-if="$store.state.search.searchData.total != $store.state.search.searchData.total_search">of {{ $store.state.search.searchData.total_search }} </span>
                                        <span v-if="$store.state.search.searchData.total > 1">funds</span>
                                        <span v-else>fund</span>
                                    </h2>
                                    <h2 v-else class="is-size-6 is-size-4-tablet has-text-weight-bold m-b-5 m-t-5 is-hidden-tablet">
                                        {{$store.state.shortlist.fullshortlist.length}}
                                        <span v-if="$store.state.shortlist.fullshortlist.length > 1">funds</span>
                                        <span v-else>Fund</span>
                                    </h2>
                                </div>
                                <div class="column is-6 is-hidden-tablet px-0 is-align-self-center text-align-right">
                                    <div class="collapse mr-3">
                                        <a class="is-has-text-nowrap expand-collapse-link expand-collapse has-text-underline is-size-7" @click="showall = !showall">
                                            <template v-if="showall">
                                                Collapse All
                                            </template>
                                            <template v-else>
                                                Expand All
                                            </template>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <ul class="sort-links is-hidden-mobile mb-0" v-if="$store.state.search.searchData.data.length !== 1">
                                <li>
                                    <div class="columns px-3 mt-2">
                                        <div>
                                            <p class="mt-2 mr-2 mb-2">Sort by</p>
                                        </div>
                                        <div>
                                            <b-select class="sort-select-1" v-model="sorting1" placeholder="-- select --">
                                                <option
                                                    v-for="s in sortinglist"
                                                    :value="s.code"
                                                    :key="s.code"
                                                    :class="s.isRequired ? 'navbar-item' : ''">
                                                    {{ s.name }}
                                                </option>
                                            </b-select>
                                            <b-select class="sort-select-2" v-model="sortDir1" placeholder="-- select --">
                                                <option v-if="highLow1 === true" value="ASC">A-Z</option>
                                                <option v-else value="DESC">High to low</option>
                                                <option v-if="highLow1 === true" value="DESC">Z-A</option>
                                                <option v-else value="ASC">Low to high</option>
                                            </b-select>
                                        </div>
                                        <div>
                                            <p class="m-2"><a class="clear-btn" @click="sorting1='CumulativeTotalReturn1Year'">Clear</a></p>
                                        </div>
                                        <div class="ml-3">
                                            <b-select :disabled="!showSecondOption" class="sort-select-1" v-model="sorting2" placeholder="-- Select --">
                                                <option
                                                    v-for="s in sortinglist2"
                                                    :value="s.code"
                                                    :key="s.code"
                                                    :class="s.isRequired ? 'navbar-item' : ''">
                                                    {{ s.name }}
                                                </option>
                                            </b-select>
                                            <b-select :disabled="!showSecondOption" class="sort-select-2" v-model="sortDir2" placeholder="-- Select --">
                                                <option v-if="highLow2 === true" value="ASC">A-Z</option>
                                                <option v-else value="DESC">High to low</option>
                                                <option v-if="highLow2 === true" value="DESC">Z-A</option>
                                                <option v-else value="ASC">Low to high</option>
                                            </b-select>
                                        </div>
                                        <div v-if="showSecondOption">
                                            <p class="m-2"><a class="clear-btn" @click="clearSorting2()">Clear</a></p>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                      </div>
                        <div
                            class="is-flex search-tabs-wrapper"
                            :class="{'is-mt-6-desktop': $store.state.search.searchData.data.length === 1}"
                            >
                            <ul class="search-tabs mt-0 w-100">
                                <li :class="{active:!$store.state.shortlist.showShortlist}"><a @click="$store.commit('shortlist/SET_SHOW_SHORTLIST',false), $store.commit('compare/SET_TYPE_COMPARE_DETAIL', 'results_page')">RESULTS<span></span></a></li>
                                <li :class="{active:$store.state.shortlist.showShortlist}"><a @click="$store.commit('shortlist/SET_SHOW_SHORTLIST',true),$store.dispatch('shortlist/getShortlist',$store.state.search), $store.commit('compare/SET_TYPE_COMPARE_DETAIL', 'shortlist')">SHORTLIST<span></span></a></li>
                            </ul>
                        </div>

                        <div v-show="!$store.state.shortlist.showShortlist">
                        <div class="search-results pb-2">
                            <div v-for="(i, index) in $store.state.search.searchData.data" class="" :key="index">
                                <div class="search-item m-b-10">
                                  <search-result :filterBenchmarkSelected="filterBenchmarkSelected" :selectedWatchlistID="selectedWatchlistID" :shortlist="true"  :showall="showall" :i="i" :ind="index + perPage*(pageCurrent -1)"></search-result>
                                </div>
                            </div>
                        </div>
                        <template v-if="$store.state.search.searchData.data">
                            <div class="p-r-80-tablet p-l-80-tablet" v-if="$store.state.search.searchData.data.length ===1">
                                <template v-if="dataSourceComparison.CumulativeTotalReturn1Year">
                                    <h2 class="is-size-6 is-size-4-tablet has-text-weight-bold has-text-centered">Ranking vs peers</h2>
                                    <h2 class="is-size-6 is-size-4-tablet has-text-centered dark-text">Category: <span class="has-text-weight-bold">{{ $store.state.search.searchData.data[0].morningstarcategories }}</span></h2>
                                    <div class="is-flex is-justify-content-center is-align-items-center not-available is-hidden-tablet m-t-10">
                                        <p class="has-text-center mb-2 is-size-7-mobile grey-text-2">
                                            <img class="h-scroll-icon" width="30" src="/img/h-scroll.svg"> Swipe table to see more
                                        </p>
                                    </div>
                                    <div class="scroll-table-wrapper pt-4 pb-0">
                                        <table class="comparison-table-1">
                                            <thead>
                                                <tr>
                                                    <td>Criteria</td>
                                                    <td>Rank</td>
                                                    <td>Out of
                                                        <button v-tooltip="{
                                                            content: `Number of funds with data for this criteria in category ${$store.state.search.searchData.data[0].morningstarcategories}`, trigger: 'click hover'
                                                        }">?</button>
                                                    </td>
                                                    <td>This Fund</td>
                                                    <td>Best Fund</td>
                                                    <td>Worst Fund</td>
                                                    <td>Median Fund</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-if="dataSourceComparison.CumulativeTotalReturn1Year">
                                                <td>NTR 1Y <button v-tooltip="{content: 'Annualised Net Total Return 1 Years', trigger: 'hover click'}">?</button></td>
                                                <td>
                                                    <span v-if="dataSourceComparison.CumulativeTotalReturn1Year.rank" class="has-text-weight-bold">{{dataSourceComparison.CumulativeTotalReturn1Year.rank}}</span>
                                                    <span v-else class="not-available">n/a</span>
                                                </td>
                                                <td><span class="has-text-weight-bold">{{dataSourceComparison.CumulativeTotalReturn1Year.total}}</span></td>
                                                <td><pos-neg :suffix="'%'" :val="dataSourceComparison.focus.CumulativeTotalReturn1Year"/></td>
                                                <td><pos-neg :suffix="'%'" :val="dataSourceComparison.maxminavg.CumulativeTotalReturn1Year.max"/></td>
                                                <td><pos-neg :suffix="'%'" :val="dataSourceComparison.maxminavg.CumulativeTotalReturn1Year.min"/></td>
                                                <td><pos-neg :suffix="'%'" :val="dataSourceComparison.median.CumulativeTotalReturn1Year"/></td>
                                            </tr>
                                            <tr v-if="dataSourceComparison.TotalReturn3Years">
                                                <td>NTR 3Y <button v-tooltip="{content: 'Annualised Net Total Return 3 Year', trigger: 'hover click'}">?</button></td>
                                                <td>
                                                    <span v-if="dataSourceComparison.TotalReturn3Years.rank" class="has-text-weight-bold">{{dataSourceComparison.TotalReturn3Years.rank}}</span>
                                                    <span v-else class="not-available">n/a</span>
                                                </td>
                                                <td><span class="has-text-weight-bold">{{dataSourceComparison.TotalReturn3Years.total}}</span></td>
                                                <td><pos-neg :suffix="'%'" :val="dataSourceComparison.focus.TotalReturn3Years"/></td>
                                                <td><pos-neg :suffix="'%'" :val="dataSourceComparison.maxminavg.TotalReturn3Years.max"/></td>
                                                <td><pos-neg :suffix="'%'" :val="dataSourceComparison.maxminavg.TotalReturn3Years.min"/></td>
                                                <td><pos-neg :suffix="'%'" :val="dataSourceComparison.median.TotalReturn3Years"/></td>
                                            </tr>
                                            <tr v-if="dataSourceComparison.TotalReturn5Years">
                                                <td>NTR 5Y <button v-tooltip="{content: 'Annualised Net Total Return 5 Year', trigger: 'hover click'}">?</button></td>
                                                <td>
                                                    <span v-if="dataSourceComparison.TotalReturn5Years.rank" class="has-text-weight-bold">{{dataSourceComparison.TotalReturn5Years.rank}}</span>
                                                    <span v-else  class="has-text-weight-bold not-available">n/a</span>
                                                </td>
                                                <td><span class="has-text-weight-bold">{{dataSourceComparison.TotalReturn5Years.total}}</span></td>
                                                <td><pos-neg :suffix="'%'" :val="dataSourceComparison.focus.TotalReturn5Years"/></td>
                                                <td><pos-neg :suffix="'%'" :val="dataSourceComparison.maxminavg.TotalReturn5Years.max"/></td>
                                                <td><pos-neg :suffix="'%'" :val="dataSourceComparison.maxminavg.TotalReturn5Years.min"/></td>
                                                <td><pos-neg :suffix="'%'" :val="dataSourceComparison.median.TotalReturn5Years"/></td>
                                            </tr>
                                            <tr>
                                                <td class="is-has-text-nowrap">OGC<button v-tooltip="{content: 'Ongoing Charge (includes Mgt Fee)', trigger: 'hover click'}">?</button></td>
                                                <td>
                                                    <span v-if="dataSourceComparison.ongoingchargecomp.rank" class="has-text-weight-bold">{{dataSourceComparison.ongoingchargecomp.rank}}</span>
                                                    <span v-else class="not-available">n/a</span>
                                                </td>
                                                <td><span class="has-text-weight-bold">{{dataSourceComparison.ongoingchargecomp.total}}</span></td>
                                                <td><pos-neg :suffix="'%'" :val="dataSourceComparison.focus.ongoingchargecomp"/></td>
                                                <td><pos-neg :suffix="'%'" :val="dataSourceComparison.maxminavg.ongoingchargecomp.min"/></td>
                                                <td><pos-neg :suffix="'%'" :val="dataSourceComparison.maxminavg.ongoingchargecomp.max"/></td>
                                                <td><pos-neg :suffix="'%'" :val="dataSourceComparison.median.ongoingchargecomp"/></td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <h2 class="is-size-6 is-size-4-tablet has-text-weight-bold has-text-centered mt-4">Top funds in category for NTR 1Y</h2>
                                    <div class="is-flex is-justify-content-center is-align-items-center not-available is-hidden-tablet m-t-10">
                                        <p class="has-text-center mb-2 is-size-7-mobile grey-text-2">
                                            <img class="h-scroll-icon" width="30" src="/img/h-scroll.svg"> Swipe table to see more
                                        </p>    
                                    </div>
                                    <div class="scroll-table-wrapper only-horizontal-scroll pt-4 pb-0">
                                        <table class="comparison-table-top-5">
                                            <thead>
                                                <tr>
                                                    <td>Rank</td>
                                                    <td>Top NTR 1Y</td>
                                                    <td class="is-white-space-nowrap">CCY<button v-tooltip="{content: 'Currency of Share Class', trigger: 'hover click'}">?</button></td>
                                                    <td class="is-white-space-nowrap">OGC<button v-tooltip="{content: 'Ongoing Charge (includes Mgt Fee)', trigger: 'hover click'}">?</button></td>
                                                    <td>NTR 3Y</td>
                                                    <td>NTR 5Y</td>
                                                    <td>
                                                        Net Assets
                                                        <button v-tooltip="{
                                                                    content: 'Fund Net assets', trigger: 'hover click'
                                                                }">?
                                                        </button></td>
                                                    <td class="is-white-space-nowrap" >3Y SD<button v-tooltip="{content: '3 Year Standard Deviation', trigger: 'hover click'}">?</button></td>
                                                    <td></td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            <template v-for="(i, index) in dataSourceTop5Comparison">
                                                <tr :id="`row-detail-${i.ISIN}`" :key="index">
                                                    <td colspan="9" class="full-column">
                                                        <span class="has-text-weight-bold">
                                                            <router-link class="has-text-underline" :to="{name:'Detailedview Comparison',params:{id:i.ISIN, showtop:5}}">
                                                                {{ i.FundBasicsName }}
                                                            </router-link>
                                                            <button v-tooltip="{content: 'Click to see fund details', trigger: 'hover click'}">?</button>
                                                        </span>

                                                    </td>
                                                </tr>
                                                <tr :key="index">
                                                    <td><span class="has-text-weight-bold">{{ i.rank_number }}</span></td>
                                                    <td>
                                                    <span class="has-text-weight-bold">
                                                        <pos-neg :val="i['CumulativeTotalReturn1Year']" :suffix="'%'"/>
                                                    </span>
                                                    </td>
                                                    <td><span>{{ i.CurrencyId }}</span></td>
                                                        <td><pos-neg :val="i.ongoingchargecomp" :suffix="'%'"/>  </td>
                                                    <td><pos-neg :val="i.TotalReturn3Years" :suffix="'%'"/></td>
                                                    <td><pos-neg :val="i.TotalReturn5Years" :suffix="'%'"/></td>
                                                    <td class="is-lowercase"><net-asset :val="i.fundnetassetgbp"/></td>
                                                    <td><pos-neg :val="i.standarddev36m" :suffix="'%'"/></td>
                                                    <td>
                                                        <Buttons :ISIN="i.ISIN" :fundId="i.fund_id" :fund_data="i"/>
                                                    </td>
                                                </tr>
                                            </template>
                                            </tbody>
                                        </table>
                                    </div>
                                    <b-button @click="$router.push({name:'Comparison',params:{id:$store.state.search.searchData.data[0].ISIN, text: $store.state.search.searchData.data[0] ? convertURL(getShort($store.state.search.searchData.data[0].FundBasicsName)) : 'default'}})" class="w-100 text-initial mt-2 pulse-button" type="is-primary">See full comparison to peers</b-button>
                                </template>
                                <template v-else>
                                    <div class="mt-5">
                                        <Preloader />
                                    </div>
                                </template>
                            </div>
                        </template>



                        <b-pagination
                            v-if="$store.state.search.searchData.total > perPage"
                            :total="$store.state.search.searchData.total"
                            v-model="pageCurrent"
                            :range-before="1"
                            :range-after="1"
                            :per-page="perPage"
                            :simple="false"
                            :rounded="false"
                            :icon-prev="'chevron-left'"
                            :icon-next="'chevron-right'"
                            aria-next-label="Next page"
                            aria-previous-label="Previous page"
                            aria-page-label="Page"
                            aria-current-label="Current page">
                        </b-pagination>
                        </div>

                        <div v-show="$store.state.shortlist.showShortlist">
                            <div class="search-results">
                                <div v-for="(i, index) in $store.state.shortlist.fullshortlist" class="search-item m-b-20" :key="index">
                                    <search-result :filterBenchmarkSelected="filterBenchmarkSelected" :isWatchlist="true" :shortlist="false" :showall="showall" :i="i" :ind="index"></search-result>
                                </div>
                                <div class="p-l-10 p-t-30" v-if="$store.state.shortlist.myShortlist.length == 0">
                                    <b-message  type="is-success" aria-close-label="Close message">
                                        <p class="has-text-weight-bold p-b-10">You have no Funds in your shortlist.
                                        </p>
                                        <p>To add items, simply click on the Fund's shortlist button on the results page.</p>
                                    </b-message>

                                </div>
                            </div>
                        </div>
                    <div class="column is-12-tablet disclaimer">
                        <Disclaimer />
                    </div>

                    </div>
                    <div class="column is-3-widescreen is-3-fullhd" ref="subRight_before">
                        <div :class="(dataListing.length>2 || this.$store.state.shortlist.showShortlist) ? 'banner-on-top' : 'banner-under-bottom'" ref="subRight">
                            <!-- <AdsGoogle /> -->
                             <AdsPartner />
                        </div>
                    </div>

                </div>
                <div class="mobile-filters is-hidden-tablet">
                    <a @click="isCardModalActive = true" >SORT</a> | <a @click="newtotal=pageTotal, basic=true">FILTERS</a>
                </div>

            <b-modal
                v-model="isCardModalActive"
                has-modal-card
                trap-focus
                :destroy-on-hide="false"
                aria-role="dialog"
                aria-label="Example Modal"
                aria-modal>
                <template >
                    <div class="modal-card" style="width: auto">
                        <header class="modal-card-head">
                            <p class="modal-card-title">SORT BY</p>
                            <button
                                type="button"
                                class="delete"
                                @click="isCardModalActive=false"/>
                        </header>
                        <section class="modal-card-body">
                            <ul class="sort-links is-justify-content-flex-start">
                                <li>
                                    <div class="columns px-3 mt-2">
                                        <div>
                                            <label class="mb-2 is-block">Level 1</label>
                                            <b-select class="sort-select-1" v-model="sorting1" placeholder="-- select --" label="Level 1">
                                                <option
                                                    v-for="s in sortinglist"
                                                    :value="s.code"
                                                    :key="s.code"
                                                    :class="s.isRequired ? 'navbar-item' : ''">
                                                    {{ s.name }}
                                                </option>
                                            </b-select>
                                            <b-select class="sort-select-2" v-model="sortDir1" placeholder="-- select --">
                                                <option v-if="highLow1 === true" value="ASC">A-Z</option>
                                                <option v-else value="DESC">High to low</option>
                                                <option v-if="highLow1 === true" value="DESC">Z-A</option>
                                                <option v-else value="ASC">Low to high</option>
                                            </b-select>
                                        </div>
                                        <div class="ml-3 m-l-0-mobile" v-if="showSecondOption">
                                            <label class="mb-2 is-block">Level 2</label>
                                            <b-select class="sort-select-1" v-model="sorting2" placeholder="-- select --">
                                                <option
                                                    v-for="s in sortinglist2"
                                                    :value="s.code"
                                                    :key="s.code"
                                                    :class="s.isRequired ? 'navbar-item' : ''">
                                                    {{ s.name }}
                                                </option>
                                            </b-select>
                                            <b-select class="sort-select-2" v-model="sortDir2" placeholder="-- select --">
                                                <option v-if="highLow2 === true" value="ASC">A-Z</option>
                                                <option v-else value="DESC">High to low</option>
                                                <option v-if="highLow2 === true" value="DESC">Z-A</option>
                                                <option v-else value="ASC">Low to high</option>
                                            </b-select>
                                        </div>
                                    </div>
                                </li>

                                <li class="mr-0">
                                    <div class="m-t-45">
                                        <a class="clear-btn" @click="sorting1='CumulativeTotalReturn1Year'">Clear</a>
                                    </div>
                                    <div v-if="showSecondOption" class="m-t-100">
                                        <a class="clear-btn" @click="clearSorting2()">Clear</a>
                                    </div>
                                </li>
                            </ul>
                            <div class="is-flex is-justify-content-center">
                                <button
                                    type="button"
                                    class="button is-primary"
                                    @click="isCardModalActive=false">Apply</button>
                            </div>
                        </section>
                    </div>
                </template>
            </b-modal>


            <b-modal has-modal-card
                :full-screen="false"
                can-cancel="outside"
                v-model="showModalAddAllFunds"
                :width="640">
                <AddFundsToWatchlistModal @update:createWatchlist="onCreateWatchlistClick($event)"/>
            </b-modal>
            <b-modal has-modal-card
                :full-screen="false"
                can-cancel="outside"
                v-model="isModalCreatedWatchlist"
                @after-leave="showModalAddAllFunds=!showModalAddAllFunds"
                :width="640">
                <watchlist-modal isAddingAllFunds></watchlist-modal>
            </b-modal>

        </div>
        </div>
    </div>
    <div class="preloader-center" v-else>
        <Preloader />
    </div>
</template>


<script>

import axios from "axios"
import commonMixin from "@/mixins/commonMixin";
import bannerMixin from "@/mixins/bannerMixin";
import AdvancedFilter from "@/components/Advancedfilter";
import BasicFilter from "@/components/Basicfilter";
import Buttons from "@/components/Buttons";
import { mapState } from 'vuex'
import PosNeg from "@/components/PosNeg";
import NetAsset from "@/components/NetAsset";
import Preloader from "@/components/Preloader"
import Disclaimer from "@/components/Disclaimer"
// import {getCat, getLegal, currency, getShort} from "../plugins/cats"

//import DetailedView from "../components/Detailedview"
import SearchResult from "@/components/SearchResult";
import CurrencyToggle from "@/components/CurrencyToggle";
import auth from "@/store/modules/auth"
import PageHelpDropdown from '@/components/PageHelpDropdown.vue';
import AddFundsToWatchlistModal from '@/components/AddFundsToWatchlistModal.vue';
import WatchlistModal from '@/components/WatchlistModal.vue';
import AdsGoogle from '@/components/AdsGoogle.vue';
import AdsPartner from '@/components/AdsPartner.vue';
export default {
    name: 'Searchlist',
    components: {
        CurrencyToggle,
        SearchResult,
        AdvancedFilter,
        BasicFilter,
        Buttons,
        PosNeg,
        Preloader,
        NetAsset,
        Disclaimer,
        AddFundsToWatchlistModal,
        WatchlistModal,
        AdsGoogle,
        PageHelpDropdown,
        AdsPartner
    },
    props: {},
    mixins: [commonMixin,bannerMixin],
    data() {
        return {
            listPlatform: null,
            listCompareBenchmark: null,
            platformAllCheck: false,
            platformNoCheck: false,
            selectedDisabled: false,
            platformAllCheckSaved: false,
            platformNoCheckSaved: false,
            filterPlatformOptions: [],
            filterPlatformOptionsSaved: [],
            filterBenchmarkSelected: { "benchmarkTD": "0", "benchmark1Y": "0", "benchmark3Y": "0", "benchmark5Y": "0" },
            isActive: true,
            isLoaded: true,
            showModalAddAllFunds: false,
            isModalCreatedWatchlist: false,
            aToZ:["ETF / non ETF", "morningstarcategories", "LegalStructure", "CompanyBasicsName", "FundBasicsName", "IndexFund"],
            searchView:true,
            clean:false,
            absoluteTotal:0,
            show:[],
            openAll:false,
            ll:[],
            newtotal:0,
            filterPresets:{},
            filterReturned:null,
            basic:false,
            advanced:false,
            myhistory:true,
            advancedFilter:AdvancedFilter,
            basicFilter:BasicFilter,
            showSecondOption: this.$store.state.search.isShowSecondOption,
            keywordsvisible:false,
            currencyNative: true,
            detailed: {},
            showall: false,
            search: "",
            searchtitle: "",
            isin: [],
            searchtext: "",
            listing: [],
            pageCurrent: 1,
            pageTotal: 0,
            preFilterTotal: 0,
            perPage: 100,
            keyword:"",
            userSearchHistory:[],
            isCardModalActive: false,
            isShareUrl: false,
            isWorkingOnFilters: false,
            dataSourceComparison: [],
            beforePage: '',
            selectedWatchlistID: null,
            searchlist: [
                {search: "isa eligible", display: "funds tradable in an ISA", code: "ISA"},
                {search: "sipp eligible", display: "funds tradable in a SIPP", code: "SAPP"},
                {search: "currency hedged", display: "funds with currency hedged share classes", code: "currency_hedged"},
                {search: "leveraged", display: "funds allowed to use leverage", code: "leveraged"},
                {search: "no leverage", display: "funds NOT allowed to use leverage", code: "no_leverage"},
                {search: "performance fee", display: "funds charging a performance fee", code: "performance_fee"},
                {search: "no performance fee", display: "funds NOT charging a performance fee", code: "no_performance_fee"},
                //{search: "esg", display: "ESG funds", code: "esg"},
                {search: "environment social governance esg", display: "ESG funds", code: "esg"},
                //{search: "", display: "funds with ETF share classes", code: "etf"},
                {search: "exchange traded etf", display: "funds with ETF share classes", code: "etf"},
                //{search: "accumulation units", display: "funds with accumulation units", code: "accumulation"},
                {search: "accumulation share class units", display: "funds with accumulation units", code: "accumulation"},
                //{search: "income units", display: "funds with income units", code: "income"},
                {search: "income units share class", display: "funds with income units", code: "income"},
                {search: "benchmark", display: "funds with a benchmark", code: "benchmark"},
                {search: "no benchmark unconstrained", display: "funds with NO benchmark (unconstrained)", code: "no_benchmark"},
                {search: "passive index", display: "index funds (passive)", code: "passive"},
                {search: "active", display: "active funds", code: "active"},
                {search: "physical replication", display: "index funds using physical replication", code: "physical"},
                {search: "discount  trusts", display: "trusts trading at a discount", code: "discount"},
                {search: "premium trusts", display: "trusts trading at a premium", code: "premium"},
                {search: "oeics", display: "OEICs", code: "Open Ended Investment Company"},//??
                {search: "investment trusts", display: "investment trusts", code: "Closed Ended Investment Company"},//??
                {search: "unit trusts", display: "unit trusts", code: "Unit Trust"},
                {search: "sicavs", display: "SICAVs", code: "SICAV"},
                {search: "open ended investment trusts", display: "open ended funds", code: "Open Ended Investment Company"},
                {search: "closed ended", display: "closed ended funds", code: "Closed Ended Investment Company"},
                {search: "venture capital trusts vct", display: "VCT", code: "vct"},//??
            ],
            sortinglist:[
                {name:"Net total return YTD",code:"CumulativeTotalReturnTD",show2:false, isRequired: false, predefined: 'DESC'},
                {name:"Net total return 1Y",code:"CumulativeTotalReturn1Year",show2:false, isRequired: false, predefined: 'DESC'},
                {name:"Net total return 3Y",code:"TotalReturn3Years",show2:false, isRequired: false, predefined: 'DESC'},
                {name:"Net total return 5Y",code:"TotalReturn5Years",show2:false, isRequired: false, predefined: 'DESC'},
                {name:"Fund name",code:"FundBasicsName",show2:false, isRequired: false, predefined: 'ASC'},
                {name:"Net assets (£m)",code:"fundnetassetgbp",show2:false, isRequired: false, predefined: 'DESC'},
                {name:"Yield",code:"yield12m",show2:false, isRequired: false, predefined: 'DESC'},
                {name:"Ongoing charge",code:"ongoingchargecomp",show2:false, isRequired: false, predefined: 'ASC'},
                {name:"Years since launch",code:"years_since_launch",show2:false, isRequired: true, predefined: 'DESC'},
                {name:"Manager tenure",code:"manager tenure",show2:false, isRequired: true, predefined: 'DESC'},
                {name:"Number of holdings",code:"NumberOfHolding",show2:false, isRequired: true, predefined: 'DESC'},
                {name:"3Y Sharpe Ratio",code:"sharperatio3Y",show2:false, isRequired: true, predefined: 'DESC'},
                {name:"3Y Standard deviation",code:"standarddev36m",show2:false, isRequired: true, predefined: 'ASC'},
                {name:"Premium/Discount to NAV",code:"premium/discount to NAV",show2:false, isRequired: true, predefined: 'ASC'},
                {name:"Asset manager",code:"CompanyBasicsName",show2:true, isRequired: false, predefined: 'ASC'},
                {name:"Fund structure",code:"LegalStructure",show2:true, isRequired: false, predefined: 'ASC'},
                {name:"ETF/Non ETF",code:"ETF / non ETF",show2:true, isRequired: false, predefined: 'ASC'},
                {name:"Risk rating",code:"riskrating_6M",show2:true, isRequired: false, predefined: 'ASC'},
                //{name:"fund category",code:"LegalStructure",show2:true},
                {name:"Morningstar category",code:"morningstarcategories",show2:true, isRequired: false, predefined: 'ASC'},

                {name:"Management style",code:"IndexFund",show2:true, isRequired: false, predefined: 'ASC'},
            ], //morningstarcategories LegalStructure CompanyBasicsName FundBasicsName
            sorting1: this.$store.state.search.order1,
            sorting2: this.$store.state.search.order2,
            sortDir1: this.$store.state.search.sortDir1,
            sortDir2: this.$store.state.search.sortDir2,
            auth,
            dataSourceTop5Comparison: [],
        }
    },
    computed: {
        ...mapState('search', {
            searchData: 'searchData',
        }),
        sortinglist2(){
            return this.sortinglist.filter( obj => {
                return obj.code !== this.$store.state.search.order1;
            });
        },
        dataListing(){
            if(this.$store.state.search.searchData.data) return this.$store.state.search.searchData.data
            else return [];
        },
        dinotext() {
            if(this.search.length > 0){
                const words = this.search.split(" ");
                return this.searchlist.filter((result) => {
                    for (let i=0; i <= words.length; i++){
                        if(typeof words[i] !== 'string') return false
                        if(words[i] == '') return false
                        let w = words[i].toLowerCase()
                        if(result.search.includes(w) && words[i] != ""){
                            return true
                        }
                    }
                    return false;
                });
            }
            return []
        },
        showHist(){
            if(this.search=="" && this.userSearchHistory.length > 0){
                return true;
            }
            return false
        },
        highLow1(){
            if( this.aToZ.includes(this.sorting1)){
                return true
            }
            return false
        },
        highLow2(){
            if( this.aToZ.includes(this.sorting2)){
                return true
            }
            return false
        },
        checkSearchEmpty() {
            return this.$store.state.search.lastSearch.text!=='' ? this.$store.state.search.lastSearch.text.replace(/[,]/g, ' ') : 'All'
        },
        isSpreadBenchmarkAdvancedFilter() {
            const {minMaxBenchmarkytd, minMaxBenchmark1y, minMaxBenchmark3y, minMaxBenchmark5y} = this.$store.state.search.provisionalFilters
            return (minMaxBenchmarkytd && minMaxBenchmarkytd.length > 0)
                || (minMaxBenchmark1y && minMaxBenchmark1y.length > 0)
                || (minMaxBenchmark3y && minMaxBenchmark3y.length > 0)
                || (minMaxBenchmark5y && minMaxBenchmark5y.length > 0)
        },
        benchmarkFilterSelected() {
            return this.$store.state.search.compareBenchmarkFilter
        }
    },

    methods: {
        async filterPlatform() {
            let dataFilter = {
                fund_exists_platform: undefined,
                platform_ids: [],
                platform_selected: [],
            };
            if (this.platformAllCheck) {
                dataFilter["fund_exists_platform"] = true
                this.platformAllCheckSaved = this.platformAllCheck
                this.platformNoCheckSaved = false
            } else if (this.platformNoCheck) {
                dataFilter["fund_exists_platform"] = false
                this.platformAllCheckSaved = false
                this.platformNoCheckSaved = this.platformNoCheck
            } else {
                if (this.filterPlatformOptions.length) {
                    dataFilter["platform_ids"] = this.filterPlatformOptions.map(function(item) {
                                                return item['id'];
                                            });
                    this.filterPlatformOptionsSaved = dataFilter.platform_selected = this.filterPlatformOptions.map(function(item) {
                                                        return item['platform'];
                                                    });
                } else {
                    dataFilter.platform_selected = []
                    dataFilter["platform_ids"]  = []
                    this.filterPlatformOptionsSaved = []
                }
                this.platformAllCheckSaved = false
                this.platformNoCheckSaved = false
            }
            this.$store.commit("search/SET_PLATFORM_FILTER", {...dataFilter, filter_action: "platform"})
            this.$refs.platformFilter.toggle()
            await this.$store.dispatch("search/apiCall", this.$store.state.search.lastSearch)
            this.getTableComparison();
            this.getTableTop5Comparison();
        },
        clearFilterCompareBenchmark() {
            let platformFilter = this.$store.state.search.platformFilter;
            platformFilter.filter_action && delete platformFilter.filter_action;
            this.$store.commit("search/SET_PLATFORM_FILTER", platformFilter);
        },
        async filterCompareBenchmark() {
            // if (this.filterBenchmarkSelected) {
                this.$store.commit("search/SET_COMPARE_BENCHMARK_FILTER", this.filterBenchmarkSelected)
            // } else {
            //     this.$store.commit("search/SET_COMPARE_BENCHMARK_FILTER", null)
            // }
            let platformFilter = this.$store.state.search.platformFilter;
            this.$store.commit("search/SET_PLATFORM_FILTER", { ...platformFilter, filter_action: "benchmark"})
            axios.post('/log-data-benchmark', {
                isin_benchmark: this.filterBenchmarkSelected.ISIN,
                user_id: this.$store.state.auth.userProfile ? this.$store.state.auth.userProfile.id || '' : '',
            })
            // await this.$store.dispatch("search/apiCall", this.$store.state.search.lastSearch)
            // this.getTableComparison();
            // this.getTableTop5Comparison();
        },

        addAllFundsClick () {
            if (this.$store.state.shortlist.myShortlist.length) {
                this.showModalAddAllFunds = ! this.showModalAddAllFunds
            } else {
                this.$toast.error('Please add funds to shortlist.')
            }
        },
        onCreateWatchlistClick(){
            this.isModalCreatedWatchlist = !this.isModalCreatedWatchlist
            this.showModalAddAllFunds = !this.showModalAddAllFunds
        },
        checkLimited(searchData) {
            if(this.$store.state.auth.authenticated) {
                if(this.$store.state.auth.hittingLimit == 'advanced-filter') {
                    this.advanced = true;
                    this.sorting1 = searchData.sorting.f1;
                    this.sorting2 = searchData.sorting.f2;
                }
                else if(this.$store.state.auth.hittingLimit == 'sorting-option1') {
                    this.sorting1 = this.$store.state.auth.sortingLimit;
                    this.sorting2 = searchData.sorting.f2;
                    this.$store.commit("search/SET_SORTING1",this.sorting1)
                }
                else if(this.$store.state.auth.hittingLimit == 'sorting-option2') {
                    this.sorting1 = searchData.sorting.f1;
                    this.sorting2 = this.$store.state.auth.sortingLimit;
                    this.$store.commit("search/SET_SORTING2",this.sorting2)
                } else {
                    this.sorting1 = searchData.sorting.f1;
                    this.sorting2 = searchData.sorting.f2;
                }
            }
            else {
                this.sorting1 = searchData.sorting.f1;
                this.sorting2 = searchData.sorting.f2;
            }
            this.sortDir1 = searchData.sorting.d1;
            this.sortDir2 = searchData.sorting.d2;
            if(this.sorting1!=="CumulativeTotalReturn1Year") this.isShareUrl = true;
        },
        clearSorting2() {
            if(this.showSecondOption) {
                this.sorting2 = "CumulativeTotalReturn1Year";
                this.sortDir2 = "DESC";
            }
        },
        currencyChange(notRecallAPI){
            if (!notRecallAPI) {
                this.$store.dispatch("search/reApiCall")
            }
            this.$store.dispatch("shortlist/getShortlist")
            this.getTableComparison();
            this.getTableTop5Comparison();
        },
        historySearch(s){
            if(s.type=="keyword"){
                this.keywordsearch(s);
            }
            else {
                this.search = s.search
                this.searchapi()
            }
        },
        clearAll(){
            this.showall = false;
            this.clean = !this.clean
            this.pageCurrent = 1
            this.$store.commit("search/SET_CURRENT_PAGE",1)
            this.$store.commit("search/SET_FILTERS",{})
            this.$store.dispatch("search/reApiCall")
            this.$store.commit("search/SET_PROV_FILTERS",{})
            this.$store.commit("search/SET_PROVISIONAL_RES",{})
            this.$store.commit("search/SET_COUNT_BASIC", 0);
            this.$store.commit("search/SET_COUNT_ADVANCE", 0);
        },
        searchType() {
            const re = /\b([A-Z]{2})((?![A-Z]{10}\b)[A-Z0-9]{10})\b/gi;
            const matches = this.search.match(re)
            if (matches) {
                this.isin = matches
                this.searchtext = ""
            }
            else {
                this.isin = []
                this.searchtext = this.search
            }

            this.searchtitle = this.search

        },
        searchapi(newsearch) {
            if(newsearch){
                this.filterReturned={}
            }
            this.searchType()
            if (this.searchtext) {
                this.textSearch()
            } else {
                this.isinSearch()
            }
        },
        keywordsearch(i) {
            this.searchtitle = i.display
            this.apiCall("keyword",i.code)
            this.search=i.display
        },
        isinSearch() {
            this.apiCall("isin",this.isin.join(','))
        },
        textSearch() {
            this.apiCall("text",this.searchtext)
        },
        lastSearch(){
          if(this.userSearchHistory.length > 0){
              const x = this.userSearchHistory[0]
              this.apiCall(x.type, x.search)
          }
        },
        provisionalCount(obj){
            if(this.userSearchHistory.length > 0){
                const x = this.userSearchHistory[0]
                let params = {
                    search: x.search,
                    //native: this.currencyNative,
                }
                //if(this.filterReturned){
                Object.assign(params,this.filterReturned)
                //}
                Object.assign(params,obj)
                axios.get('/search/'+x.type, {
                    params: params
                })
                .then((response) => {
                    this.newtotal= response.data.total
                })
                .catch(() => {
                })
            }
        },
        getFilterValues(type,search){
            axios.get('/search/'+type, {
                params: {
                    search: search,
                    native: this.$store.state.search.currency,
                    maxmin:true
                }
            })
                .then((response) => {
                    this.filterPresets = response.data[0]
                })
                .catch(() => {
                })
        },
        switchIt(){
            if(this.$store.state.auth.authenticated) {
                this.basic = !this.basic
                this.advanced = !this.advanced
            } else {
                this.backToPageLogin('advanced-filter')
            }
        },
        goToTopPageSearchList (value) {
            if (value) {
                window.scrollTo(0, 0)
            }
            this.getTableComparison();
            this.getTableTop5Comparison();
        },
        openPopupAdvancedFilter () {
            if (!this.auth.state.authenticated) {
                this.backToPageLogin('advanced-filter')
            } else {
                this.newtotal = this.pageTotal
                this.advanced = true
            }
        },
        backToPageLogin(limit) {
            this.$store.commit("auth/SET_HITTING_LIMIT", limit)
            this.$router.push('/login/max-5')
        },
        windowScroll() {
            if(this.dataListing.length>2 || this.$store.state.shortlist.showShortlist) {
                this.handleScroll()
            }
            if(window.scrollY) this.isActive=false;

        },
        getShortNameOfAssetManager(assetManager) {
            let arr = [];
         
            let managerSelection = this.$store.state.search.managerSelection;
            assetManager.forEach(element => {
                const find = managerSelection.find(({ CompanyBasicsName }) => CompanyBasicsName === element);
                if(find){
                    arr.push(find.am_short)
                }
                else{
                    arr.push(element)
                }
            });
            return Array.from(new Set(arr))
        },
        async handleTypeSearch(searchData) {
            //trick with ETF/ non ETF option
            if (searchData.type == "ticker") {
                this.$router.push({name:"Home", params: {searchData}});
                return;
            }
            if(searchData.sorting.f1 === "ETF / non ETF") {
                searchData.sorting.d1 = searchData.sorting.d1 === "ASC" ? "DESC" : "ASC";
            }
            if(searchData.sorting.f2 === "ETF / non ETF") {
                searchData.sorting.d2 = searchData.sorting.d2 === "ASC" ? "DESC" : "ASC";
            }

            this.$store.commit("search/SET_RELOAD_SEARCH", true)
            this.$store.commit("search/SET_SORTDIR1", searchData.sorting.d1)
            this.$store.commit("search/SET_SORTDIR2", searchData.sorting.d2)
            this.$store.commit("search/SET_SORTING1", searchData.sorting.f1)
            this.$store.commit("search/SET_SORTING2", searchData.sorting.f2)
            this.$store.commit("search/SET_CURRENCY", searchData.currency === 'N' ? 'native' : 'gbp')
            this.$store.commit("search/SET_COUNT_BASIC", searchData.filters.count_filters_basic ? searchData.filters.count_filters_basic : 0);
            this.$store.commit("search/SET_COUNT_ADVANCE", searchData.filters.count_filters_advance ? searchData.filters.count_filters_advance : 0);
            
            this.checkOptionShowAll(this.sorting1)
            this.checkOptionShowAll(this.sorting2)
            this.checkLimited(searchData);
            if (!this.$store.state.search.searchData.searchdata_id) {
                await this.$store.dispatch("search/apiCall", {...searchData, isReload: true})
                if (this.$store.state.search.searchData.ticker_search) {
                    searchData.type = "ticker"
                    this.$router.push({name:"Home", params: {searchData}});
                    return;
                }
            }
            await this.$store.dispatch("search/getMaxmin")
            this.$store.commit("search/SET_ABSOLUTETOTAL", searchData.total);
            this.$bus.$emit("loadingPage", false)
            this.isLoaded = true
        },
        checkOptionShowAll(value) {
            const optionShowAll = ['CompanyBasicsName', 'LegalStructure', 'riskrating_6M', 'sharperatio3Y'];
            if(optionShowAll.includes(value)) this.showall=true
        },
        checkBasicFilterShowAll(basic) {
            if(basic.fundtype!=='' || basic.assetManager.length>0 || basic.riskrating_6M.length>0) this.showall=true;
        },
        async getTableComparison() {
            if(this.$store.state.search.searchData.data) {
                if(this.$store.state.search.searchData.data.length===1) {
                    await axios.get('/search/getcomparison/' + this.$store.state.search.searchData.data[0].ISIN, {params: {
                        native: this.$store.state.search.currency,
                        type: "CumulativeTotalReturn1Year",
                    }})
                    .then((response) => {
                        this.dataSourceComparison = response.data;
                    })
                    .catch((error) => {
                        alert(error)
                    })
                }
            }
        },
        async getTableTop5Comparison() {
            if(this.$store.state.search.searchData.data && this.$store.state.search.searchData.data.length===1) {
                await axios.get('/api/v1/comparison/top-funds', {params: {
                    isin: this.$store.state.search.searchData.data[0].ISIN,
                    native: this.$store.state.search.currency,
                    type: "CumulativeTotalReturn1Year",
                }})
                .then((response) => {
                    this.dataSourceTop5Comparison = response.data.data;
                })
                .catch((error) => {
                    alert(error)
                })
            }
        },
        drawLineBetweenElements(element1, element2, svgContainer) {

            // Create an SVG line element
            const line = document.createElementNS("http://www.w3.org/2000/svg", "line");
            line.setAttribute("x1", element1.offsetLeft - element2.offsetLeft);
            line.setAttribute("y1", 0);
            line.setAttribute("x2", element2.offsetWidth / 2);
            line.setAttribute("y2", svgContainer.offsetHeight);
            line.setAttribute("stroke", "white"); // Line color
            line.setAttribute("stroke-width", "2"); // Line thickness
            line.setAttribute("marker-start", "url(#arrow-start)"); // Arrow at the start of the line
            line.setAttribute("marker-end", "url(#arrow-end)");   // Arrow at the end of the line
            const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            svg.innerHTML = `
                <defs>
                    <marker id="arrow-end" markerWidth="10" markerHeight="10" refX="6" refY="3" orient="auto" markerUnits="strokeWidth">
                        <path d="M0,0 L6,3 L0,6 Z" fill="white" />
                    </marker>
                </defs>
                <defs>
                    <marker id="arrow-start" markerWidth="10" markerHeight="10" refX="0" refY="3" orient="auto" markerUnits="strokeWidth">
                        <path d="M6,0 L0,3 L6,6 Z" fill="white" />
                    </marker>
                </defs>
            `
            svg.style.cssText = `
                position: absolute; 
                top: 0; 
                left: 0; 
                width: 100%; 
                height: 100%;
            `;
            svg.appendChild(line);
            // Append the line to the SVG container
            svgContainer.appendChild(svg);
        },
        hightLightSearch(){
            const skipHighLighting = this.$cookies.get('skip-first-highlighting');
            let element2 = document.getElementById("load-fixed");
            if (skipHighLighting || !element2) {
                return;
            }

            this.$cookies.set('skip-first-highlighting', true, '1d');
            const sectionFixed = document.createElement("div");
            sectionFixed.classList.add("background-fixed");
            document.body.classList.add("fixed");
            document.body.appendChild(sectionFixed);

            let element1 = document.getElementById("benchmark-filter");
            let pos1 = element1.getBoundingClientRect().top;
            let pos2 = element1.getBoundingClientRect().left;
            let height1 = element1.offsetHeight;
            let width1 = element1.offsetWidth;

            let pos3 = element2.getBoundingClientRect().top;
            let pos4 = element2.getBoundingClientRect().left;

            const wrapperFixed = document.createElement("div");
            wrapperFixed.style.cssText = `
                position: fixed;
                top: ${pos1 + height1}px;
                height: ${pos3 - (pos1 + height1)}px;
                z-index: 111;
                left: ${pos4}px;
                width: ${width1 + pos2 - pos4}px;
                display: flex;
                align-items: center;
                justify-content: center;
            `;
            

            const textFixed = document.createElement("div");
            textFixed.textContent = 'COMPARE YOUR FUND TO MAIN INDEXES';
            textFixed.style.cssText = `
                padding: 5px;
                background: #4173ea;
                color: #fff;
                font-weight: bold;
                z-index: 11;
            `;
            
            wrapperFixed.appendChild(textFixed)
            document.body.appendChild(wrapperFixed);
            this.drawLineBetweenElements(element1, element2, wrapperFixed)
            document.body.addEventListener("click", function () {
                document.body.classList.remove("fixed");
                sectionFixed.remove();
                wrapperFixed.remove();
            });
        }

    },
    watch: {
        pageCurrent: function (v) {
            if (this.pageCurrent == this.$store.state.search.currentPage)
                return;
            this.$store.commit("search/SET_CURRENT_PAGE",v)
            this.$store.dispatch("search/reApiCall").then(
                window.scrollTo(0, 0)
            )
            window.scrollTo(0, 0)
            var self = this;
            setTimeout(function(){
                self.isLoaded = false
            }, 1000)
        },
        sorting1(value){
            this.checkOptionShowAll(value);
            let listOptionsToCheck = ['years_since_launch', 'manager tenure', 'NumberOfHolding', 'standarddev36m', 'premium/discount to NAV']
            if (listOptionsToCheck.includes(value) && !this.auth.state.authenticated && !this.isShareUrl) {
                this.backToPageLogin('sorting-option1')
                this.$store.commit("auth/SET_SORTING_LIMIT", value)
            } else {
                let result = this.sortinglist.find(obj => {
                    return obj.code == this.sorting1 && obj.show2 === true
                })
                if (result){
                    this.showSecondOption = true
                    this.sorting2 = "CumulativeTotalReturn1Year";
                    this.sortDir2 = "DESC";
                }
                else{
                    this.showSecondOption = false
                    this.sorting2 = null
                    this.sortDir2 = "DESC";
                }
                this.$store.commit("search/SET_SHOW_SECOND_OPTION", this.showSecondOption);
                this.$store.commit("search/SET_SORTING1",this.sorting1)
                this.$store.commit("search/SET_SORTING2",this.sorting2)
                this.$store.commit("search/SET_CURRENT_PAGE",1)
                if(this.aToZ.includes(this.sorting1) && this.sortDir1 != "ASC" && !this.isShareUrl){
                    this.sortDir1 = "ASC"
                    return
                }

                let findResult = this.sortinglist.find(obj => {
                    return obj.code == this.sorting1;
                })
                if(findResult && this.sortDir1 !== findResult.predefined && !this.isShareUrl) this.sortDir1 = findResult.predefined;
                else this.$store.dispatch("search/reApiCall")

                this.$store.dispatch('shortlist/getShortlist',this.$store.state.search)
                this.showall = true
            }
            if(this.isShareUrl && this.sorting2===null && this.sortDir2==='DESC') this.isShareUrl=false;
        },
        sorting2(n){
            this.checkOptionShowAll(n);
            let listOptionsToCheck = ['years_since_launch', 'manager tenure', 'NumberOfHolding', 'standarddev36m', 'premium/discount to NAV']
            if (listOptionsToCheck.includes(n) && !this.auth.state.authenticated && !this.isShareUrl) {
                this.backToPageLogin('sorting-option2');
                this.$store.commit("auth/SET_SORTING_LIMIT", n)
            } else {
                this.pageCurrent = 1
                this.$store.commit("search/SET_CURRENT_PAGE",1)
                this.$store.commit("search/SET_SORTING2",this.sorting2)

                let findResult = this.sortinglist.find(obj => {
                    return obj.code == this.sorting2;
                })
                if(findResult && this.sortDir2 !== findResult.predefined && !this.isShareUrl) this.sortDir2 = findResult.predefined;
                else if (this.sorting2) this.$store.dispatch("search/reApiCall")
                this.$store.dispatch('shortlist/getShortlist',this.$store.state.search)
            }
            if(this.isShareUrl) this.isShareUrl=false;
        },
        sortDir1(v){
            this.$store.commit("search/SET_SORTDIR1", v)
            this.$store.dispatch("search/reApiCall")
            this.$store.dispatch('shortlist/getShortlist',this.$store.state.search)

        },
        sortDir2(v){
            this.$store.commit("search/SET_SORTDIR2", v)
            this.$store.dispatch("search/reApiCall")
            this.$store.dispatch('shortlist/getShortlist',this.$store.state.search)

        },
        '$store.state.shortlist.myShortlist': {
            handler(value) {
                localStorage.setItem('shortList', JSON.stringify(value));
            }
        },
        '$store.state.search.filters': {
            handler() {
                const filters = this.$store.state.search.filters;
                const minSharpeRatio = Number(this.$store.state.search.maxMins.minsharperatio3y)
                const maxSharpeRatio = Number(this.$store.state.search.maxMins.maxsharperatio3y)
                if (filters.minMaxSharperatio3Y) {
                    if (filters.minMaxSharperatio3Y.length > 0 && (Math.min(...filters.minMaxSharperatio3Y) > minSharpeRatio || Math.max(...filters.minMaxSharperatio3Y) < maxSharpeRatio)) {
                        this.showall = true
                    }
                }
            }
        },
        searchData() {
            this.$router.replace({name:"Results", params: {id: this.searchData.searchdata_id}})
        }
    },
    async created() {
        axios.get('/comparebenchmark')
            .then((response) => {
                this.listCompareBenchmark = response.data
                let compareBenchmarkFilter = this.$store.state.search.compareBenchmarkFilter || 'GB00B3TYHH97';
                this.filterBenchmarkSelected = this.listCompareBenchmark.find((item) => item.ISIN === compareBenchmarkFilter.ISIN)
                if (this.filterBenchmarkSelected && this.$store.state.search.currency !== 'gbp') {
                    axios.get('/search/saveccytoggledata',
                        {
                            params: {
                                source: this.$store.state.compare.typeCompareDetail,
                                toggle: 'gbp'
                            }
                        }
                    )
                    this.$store.commit("search/SET_CURRENCY", 'gbp')
                    this.currencyChange(true)
                }
            })
            
        if (this.$store.state.search.platformFilter) {
            if (this.$store.state.search.platformFilter.fund_exists_platform !== undefined) {
                if (this.$store.state.search.platformFilter.fund_exists_platform) {
                    this.platformAllCheckSaved = true
                } else {
                    this.platformNoCheckSaved = true
                }
            } else {
                this.filterPlatformOptionsSaved = this.$store.state.search.platformFilter.platform_selected
            }
        }
        if(!this.$store.state.search.isNewSearchSection) {
            this.$bus.$emit("loadingPage", true)
            this.isLoaded = false
            await axios.get(`/results/${this.$route.params.id}/shared`)
                .then(async (response) => {
                    await this.handleTypeSearch(response.data);
                })
                .catch(() => {})
        } else {
            this.$store.dispatch("search/getMaxmin")
            this.$store.commit("search/SET_NEW_SEARCH_SECTION", false)
        }

        if(this.$store.state.shortlist.showShortlist) this.$store.commit('compare/SET_TYPE_COMPARE_DETAIL', 'shortlist')
        else this.$store.commit('compare/SET_TYPE_COMPARE_DETAIL', 'results_page')
        this.getTableComparison();
        this.getTableTop5Comparison();
        this.pageCurrent = this.$store.state.search.currentPage
        if(this.$store.state.search.lastSearch.type && this.$gtag){
            this.$gtag.event("search", {
                'event_category': this.$store.state.search.lastSearch.type,
                'event_label': this.$store.state.search.lastSearch.text,
                'value': this.$store.state.search.searchData.total_search
            })
        }
        if(JSON.parse(localStorage.getItem("shortList")))
            this.$store.commit("shortlist/SET_MY_SHORTLIST", JSON.parse(localStorage.getItem("shortList")));
        window.addEventListener('scroll', this.windowScroll);
        this.$route.meta.savedPosition && window.scrollTo({
          top: this.$route.meta.savedPosition.y,
          left: this.$route.meta.savedPosition.x
        })

        axios.get('/platform')
        .then((response) => {
            this.listPlatform = response.data.sort( function (a, b) {
                if (a.platform < b.platform) {
                    return -1;
                }
                if (a.platform > b.platform) {
                    return 1;
                }
                return 0;
            });
            if (this.$store.state.search.platformFilter) {
                if (this.$store.state.search.platformFilter.fund_exists_platform !== undefined) {
                    if (this.$store.state.search.platformFilter.fund_exists_platform) {
                        this.platformAllCheck = true
                    } else {
                        this.platformNoCheck = true
                    }
                    this.selectedDisabled = true
                } else if (this.$store.state.search.platformFilter.platform_ids && this.$store.state.search.platformFilter.platform_ids.length) {
                    this.filterPlatformOptions = this.listPlatform.filter((item) =>  this.$store.state.search.platformFilter.platform_ids.includes(item.id));
                }
            }
        });
    },
    mounted() {
        this.selectedWatchlistID = this.$router.currentRoute.params.selectedWatchlistID
        window.onpopstate = () => {
            if(this.basic) { history.go(1); }
        };
        this.$router.beforeEach((to, from, next) => {
            if(from.name=='Results' && (to.path=='/' || to.path=='/about' || to.path=='/contact' || to.path=='/faq')) {
                if((this.basic || this.advanced) && this.isWorkingOnFilters) {
                    this.$buefy.dialog.confirm({
                        type: 'is-danger',
                        hasIcon: true,
                        message: 'Exit without saving changes?',
                        onConfirm: () => {
                            this.basic = false;
                            this.advanced = false;
                            this.isWorkingOnFilters = false;
                            this.$store.commit("search/SET_PROV_FILTERS",this.$store.state.search.filters)
                            next();
                        }
                    })
                }
            else next();
            } else next();
        })
        this.sorting2 = this.$store.state.search.order2;
        this.$store.dispatch("search/getManagers");
        var self = this;
        setTimeout(() => {
            self.hightLightSearch();
        }, 1000)
    },
    metaInfo() {
        return {
            title: "Search Results | Pickafund",
            meta: [
                { name: 'description', content:  'Pickafund search results'},
                { property: 'og:title', content: "Search Results | Pickafund"},
            ]
        }
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.windowScroll);
    },
}

</script>

<style>
    .p-t-1 {
        padding-top: 1rem !important;
    }
    .p-b-1 {
        padding-bottom: 1rem !important;
    }
    .item-last {
        padding-bottom: 0.75rem !important;
    }
    :is(.platform-filter,.benchmark-filter) .dropdown .background {
        z-index: 51;
    }
    .platform-filter .content{
        max-width: 200px;
        overflow: hidden;
    }
    .dropdown-item {
        outline: none;
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        gap: 0.5rem;
        z-index: 51;
        position: relative;
        z-index: 1;
    }
    .dropdown-item span {
        overflow: hidden;
    }
    .dropdown-item .check {
        width: 1.25rem;
        height: 1.25rem;
        -ms-flex-negative: 0;
        flex-shrink: 0;
        border-radius: 4px;
        border: 2px solid #7a7a7a;
        transition: background 150ms ease-out;
        -webkit-transition: background 150ms ease-out;
        background: transparent;
        display: inline-block;
    }
    .dropdown-item.is-active {
        background-color: transparent !important;
        color: #153647 !important;
    }
    .dropdown-item.is-active .check   {
        background: #4855DA url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath style='fill:%23fff' d='M 0.04038059,0.6267767 0.14644661,0.52071068 0.42928932,0.80355339 0.3232233,0.90961941 z M 0.21715729,0.80355339 0.85355339,0.16715729 0.95961941,0.2732233 0.3232233,0.90961941 z'%3E%3C/path%3E%3C/svg%3E") no-repeat center center;
        border-color: #4855DA;
    }
    .platform-filter .dropdown-content {
        max-height: 350px;
        overflow-y: auto;
        padding-bottom: 0;
        text-align: left;
        min-width: 300px;
    }
    .dropdown-item-bottom {
        position: sticky;
        bottom: 0;
        left: 0;
        width: 100%;
        border-top: 1px solid #ccc;
        background-color: #fff;
        z-index: 2;
    }
    .platform-filter .dropdown-item-bottom .button.is-primary {
        background: linear-gradient(90deg, #4173ea 0%, #41bcea 100%);
        font-weight: 700;
        border: 0;
        text-transform: uppercase;
        background-color: #4855DA;
        border-color: transparent;
        color: #fff;
        font-size: 0.75em;
        border-radius: 6px;
        padding: 0.5em 1.5em;
    }
    .dropdown-item-bottom .button.btn-clear {
        min-width: auto !important;
    }
    .dropdown-item-bottom .button.btn-clear:focus {
       color: #4173EA;
       background-color: inherit;
    }
    .dropdown-item-bottom-checkbox {
        padding: 0.5rem 1rem;
        cursor: pointer;
    }
    .dropdown-item-bottom-checkbox:not(:last-child):hover {
        background: #41bcea;
        color: #fff;
    }
    .searchitem{
        width:100%;
        background: #fff;
        border-bottom:1px solid #ccc ;
        padding:10px;
        color: #000;
        font-weight: bold;
        cursor: pointer;
    }
    .searchitem:hover{
        background: #eee;
    }
    .searchbox{
        width:100%;
        position: absolute;
        top:3px;
        z-index: 5;
    }
    .platform-filter .dropdown.is-mobile-modal > .dropdown-menu {
        z-index: 51 !important;
    }
    .benchmark-filter .dropdown.is-mobile-modal > .dropdown-menu {
        z-index: 51 !important;
    }
    .btn-platform {
        font-size: 0.75em;
        border-radius: 6px;
        border: 2px solid #000093 !important;
        width: 300px;
        justify-content: space-between;
        background: #000093 !important;
        color: #fff !important;
    }
    .btn-benchmark {
        font-size: 0.75em;
        border-radius: 6px;
        border: 2px solid #FFFE00 !important;
        width: 300px;
        justify-content: space-between;
        background: #FFFE00 !important;
        color: #000 !important;
    }
    .btn-platform .icon  {
        font-size: 2rem;
        position: absolute;
        right: 0;
        width: auto !important;
        margin-right: 0 !important;
    }
    .btn-platform span:first-child {
        display: block;
        width: 100%;
    }
    .btn-platform .content {
        text-align: left;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding-right: 10px;
    }
    @media screen and (max-width: 1023px){
        .item-last {
            padding: 0.5rem 1rem;
        }
        .dropdown-item-bottom-checkbox {
            padding: 0.5rem 1.5rem;
        }
        ::v-deep .dropdown-item {
            padding: 0.3rem 1.5rem;
        }
    }
    @media screen and (max-width: 767px){
        .btn-platform {
            width: 235px;
        }
        .btn-platform .content {
            margin-right: 10px;
        }
        .benchmark-filter {
            margin-top: 0 !important;
        }
        .header-scroll-sticky-mobile {
            top: 40px; 
            position: sticky; 
            z-index: 11; 
        }
    }

    .scroll-down {
        position: absolute;
        right: 5px;
        top: -30px;
        z-index: 10;
    }

    .background-fixed {
        position: fixed;
        width: 100vw;
        height: 100vh;
        background: #2196f3b8;
        z-index: 111;
        top: 0;
    }
    body.fixed {
        height: 100vh;
        overflow: hidden;
    }
    body.fixed .benchmark-filter {
        position: relative;
        z-index: 11111;
        pointer-events: none;
    }
    body.fixed #load-fixed {
        position: relative;
        z-index: 11111;
        background: #fff;
    }
</style>



